import { KButton } from '../index'
import _ from 'lodash'

export default {
  name: 'KDefaultButton',
  functional: true,
  render(createElement, context) {
    const extendData = {
      class: {
        'default-button': true,
      },
      props: {
        type: 'light',
        outlined: true,
        hoverMode: {
          type: 'primary',
        },
      },
    }

    // 处理JSX写法的静态class
    if (typeof context.data.class === 'string' && context.data.class) {
      extendData.staticClass = context.data.class + ' ' + context.data.staticClass
    }

    const renderData = _.merge({}, context.data, extendData)
    return <KButton {...renderData}>{context.children}</KButton>
  },
}
